import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import { useI18n } from '@/hooks/useI18n';
import { Hero } from './Hero';
import { InsightSection } from './InsightSection';
import { ValueFlow } from './ValueFlow';
import { SolutionsSection } from './SolutionsSection';
import { PricingSection } from './PricingSection';
import { FeatureComparison } from './FeatureComparison';
import { PartnerLogos } from './PartnerLogos';
import { FinalCta } from './FinalCta';

export function HomePage() {
  const { t } = useI18n();
  useDocumentMeta(t.meta.home.title, t.meta.home.description);

  return (
    <>
      <Hero />
      <InsightSection />
      <ValueFlow />
      <SolutionsSection />
      <PricingSection />
      <FeatureComparison />
      <PartnerLogos />
      <FinalCta />
    </>
  );
}
